const pickNonEmptyString = (...values) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

export const normalizeWorkspaceUser = (rawUser = {}) => {
  const country = pickNonEmptyString(
    rawUser.country,
    rawUser.address_country,
    rawUser.addresscountry,
    rawUser.phoneCountryCode,
    rawUser.phoneCountry,
    rawUser.phone_country,
    rawUser.phonecountry,
  );
  const state = pickNonEmptyString(
    rawUser.state,
    rawUser.address_state,
    rawUser.addressstate,
  );
  const city = pickNonEmptyString(
    rawUser.city,
    rawUser.address_city,
    rawUser.addresscity,
  );
  const zipCode = pickNonEmptyString(
    rawUser.zip_code,
    rawUser.address_zipcode,
    rawUser.addresszipcode,
    rawUser.zipcode,
    rawUser.postalcode,
    rawUser.zip,
  );
  const county = pickNonEmptyString(
    rawUser.county,
    rawUser.address_county,
    rawUser.addresscounty,
    rawUser.district,
  );
  const organizationName = pickNonEmptyString(
    rawUser.organization_name,
    rawUser.organizationname,
    rawUser.organizationName,
    rawUser.company,
  );
  const phoneCountryCode = pickNonEmptyString(
    rawUser.phoneCountryCode,
    rawUser.phoneCountry,
    rawUser.phone_country,
    rawUser.phonecountry,
    country,
    'IN',
  ) || 'IN';
  const accountType = pickNonEmptyString(
    rawUser.account_type,
    rawUser.accounttype,
    organizationName ? 'company' : 'individual',
  ) || (organizationName ? 'company' : 'individual');

  return {
    ...rawUser,
    country,
    address_country: country,
    addresscountry: country,
    state,
    address_state: state,
    addressstate: state,
    city,
    address_city: city,
    addresscity: city,
    zip_code: zipCode,
    address_zipcode: zipCode,
    addresszipcode: zipCode,
    zipcode: zipCode,
    postalcode: zipCode,
    zip: zipCode,
    county,
    address_county: county,
    addresscounty: county,
    district: county,
    phoneCountryCode,
    phoneCountry: phoneCountryCode,
    phone_country: phoneCountryCode,
    phonecountry: phoneCountryCode,
    organization_name: organizationName,
    organizationname: organizationName,
    organizationName,
    company: organizationName,
    account_type: accountType,
    accounttype: accountType,
  };
};

export const buildWorkspaceBillingPrefill = (rawUser = {}) => {
  const user = normalizeWorkspaceUser(rawUser);
  return {
    selectedCountry: user.country || '',
    selectedState: user.state || '',
    selectedCity: user.city || '',
    phoneCountryCode: user.phoneCountryCode || 'IN',
    phoneNumber: user.phone || '',
    postalCode: user.zip_code || '',
    county: user.county || '',
    organization: user.organization_name || '',
  };
};
